import { InvoiceTaxModel } from './invoicetax.model';

export class InvoiceLineModel {
  id?: number;
  product: string;
  quantity: number;
  discount: number;
  unityAmount: number;
  taxes: Array<InvoiceTaxModel>;
  expenseAccount: string;
  customsValue: number;
  contactPropertyId: number;

  position?: number;

  // Clasificador de gastos (partida/subpartida/familia) por concepto - transitorio, no es
  // una columna de la línea, viaja al padre para guardarse aparte (ver expense.component.ts)
  clasificadorPartida?: string;
  clasificadorSubpartida?: string;
  clasificadorFamilia?: string;

  constructor() {
    this.product = "";
    this.taxes = new Array<InvoiceTaxModel>();
    this.discount = 0;
    this.quantity = 1;
    this.unityAmount = 0;
    this.expenseAccount = null;
    this.customsValue = null;
  }
}
